<template>
  <div>
    <v-toolbar height="80" dark color="#212121" flat>
      <v-btn icon @click="backToHomepage" aria-label="Zurück zur wellcomefit.ch Startseite">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>

      <v-spacer></v-spacer>
      <img class="mr-2" style="object-fit: contain" width="50px" height="50px" src="/img/roody_logo.png" />

      <v-toolbar-title class="text-subtitle-1" style="font-weight: 1000; text-transform: uppercase; font-size: 1.4rem !important">
        Online Abo
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon disabled style="visibility: hidden">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card max-width="1200" class="px-5 mt-5 mx-auto" flat>
      <v-row v-if="studioList">
        <v-col v-if="selectedStudio">
          <v-row>
            <v-col cols="12">
              <v-card-title class="d-flex justify-center text-h4 font-weight-black">{{ selectedStudio.name }}</v-card-title>
            </v-col>

            <v-col v-if="!loadingContracts" cols="12">
              <v-simple-table v-if="contractList && contractList.length > 0">
                <thead>
                  <tr>
                    <th class="text-left">Verträge</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr @click="pushToContract(contract._id)" v-for="contract in contractList" :key="contract._id" style="cursor: pointer">
                    <td>{{ contract.internalTitle }}</td>
                    <td class="d-flex justify-end align-center">
                      <v-btn icon><v-icon>mdi-pen-plus</v-icon></v-btn>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>

              <v-card v-else class="text-center pa-10 card-glass" flat style="border: 1px solid rgba(0, 150, 63, 0.2)">
                <v-icon size="72" color="primary" class="mb-4">mdi-rocket-launch-outline</v-icon>
                <h3 class="text-h5 font-weight-black mb-2" style="color: #00963f; text-transform: uppercase">Geduld zahlt sich aus!</h3>
                <p class="text-body-1 grey--text text--darken-2 mb-0">
                  Für diesen Standort sind aktuell noch keine Verträge freigeschaltet.<br />
                  Wir arbeiten auf Hochtouren daran – weitere Infos und exklusive Angebote folgen in Kürze. Stay tuned!
                </p>
              </v-card>
            </v-col>

            <v-col v-else cols="12">
              <v-progress-linear indeterminate color="primary"></v-progress-linear>
            </v-col>

            <v-col v-if="!directLink" cols="12" class="justify-center d-flex">
              <v-btn @click="selectedStudio = null" text>Zurück zur Auswahl</v-btn>
            </v-col>
          </v-row>
        </v-col>

        <v-col v-else>
          <v-row justify="center" class="mb-8 mt-4">
            <v-col cols="12" sm="8" md="6">
              <v-text-field
                class="custom-search-field"
                v-model="search"
                rounded
                filled
                append-icon="mdi-magnify"
                placeholder="Suche nach Kanton, Stadt oder PLZ"
                solo
                hide-details
                clearable></v-text-field>
            </v-col>
          </v-row>

          <v-row class="d-flex justify-center">
            <v-col cols="12" class="text-center mb-4">
              <v-chip
                :color="selectedCanton === canton ? 'primary' : 'default'"
                @click="selectedCanton = selectedCanton === canton ? null : canton"
                v-for="canton of studioCantons"
                :key="canton"
                class="ma-2"
                small>
                {{ canton }}
              </v-chip>
            </v-col>

            <v-col v-for="studio of filteredStudios" :key="studio._id" cols="12" sm="6" lg="4" class="d-flex">
              <v-card class="d-flex flex-column fill-height card-glass" style="width: 100%">
                <div class="pa-5 d-flex flex-column flex-grow-1 mx-auto text-center">
                  <v-card-subtitle class="pa-0 font-weight-black" style="font-size: 0.8rem" v-if="studio.adresse">
                    <v-icon start small>mdi-map-marker-outline</v-icon>
                    {{ studio.adresse }}
                  </v-card-subtitle>

                  <v-spacer></v-spacer>

                  <v-card-title class="card-title text-h5 font-weight-black pa-0 mt-4 mx-auto text-uppercase">
                    {{ studio.name }}
                  </v-card-title>

                  <div class="mt-4">
                    <v-btn height="40px" color="primary" class="font-weight-black" @click="selectedStudio = studio" block large>
                      mitglied werden
                      <v-icon end>mdi-arrow-right</v-icon>
                    </v-btn>
                  </div>
                </div>
              </v-card>
            </v-col>

            <v-col v-if="loading" cols="12" class="text-center pa-10">
              <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex"
import api from "@/api"

export default {
  name: "contractCreatorExtern",
  data() {
    return {
      loading: true,
      search: "",
      directLink: false,
      studioList: [],
      loadingContracts: false,
      selectedStudio: null,
      selectedUsesV2: false,
      contractList: [],
      selectedCanton: null,
    }
  },
  async created() {
    await this.fetchStudios()
  },
  methods: {
    ...mapActions("navigationStoreNotPersisted", ["toggleNavigationBarVisibility"]),

    backToHomepage() {
      window.open("https://wellcomefit.ch", "_self")
    },

    async fetchStudios() {
      try {
        let studios = await api.fetchPublicStudios()
        if (this.$route.query.studio) {
          let studio = studios.find((e) => e.code === this.$route.query.studio)
          if (studio) {
            this.directLink = true
            this.selectedStudio = studio
          }
        }
        this.studioList = studios
      } catch (error) {
        console.error("Fehler beim Laden der Studios:", error)
      } finally {
        this.loading = false
      }
    },

    pushToContract(id) {
      this.$router.push("/contract/create/" + id + "/" + this.selectedStudio._id + "/false")
    },
    pushToContractV2() {
      this.$router.push("/contract/v2/" + this.selectedStudio._id)
    },
  },
  computed: {
    ...mapState("navigationStoreNotPersisted", ["navigationVisible"]),

    filteredStudios() {
      let studios = this.studioList
      if (this.selectedCanton) {
        studios = studios.filter((e) => e.canton === this.selectedCanton)
      }
      if (this.search) {
        const searchLower = this.search.toLowerCase()
        studios = studios.filter((s) => s.name.toLowerCase().includes(searchLower) || (s.adresse && s.adresse.toLowerCase().includes(searchLower)))
      }
      return studios
    },

    studioCantons() {
      return [...new Set(this.studioList.filter((e) => e.canton).map((e) => e.canton))]
    },
  },
  watch: {
    async selectedStudio(val) {
      if (val) {
        this.selectedUsesV2 = false
        this.loadingContracts = true
        try {
          const rollout = await api.fetchContractV2PublicRollout(val._id).catch(() => null)
          if (rollout && rollout.publicFlow === "v2") {
            this.selectedUsesV2 = true
            this.contractList = []
            this.pushToContractV2()
            return
          }
          this.contractList = await api.fetchContractsPublic(val._id)
          if (this.contractList.length === 1) {
            this.pushToContract(this.contractList[0]._id)
          }
        } finally {
          this.loadingContracts = false
        }
      } else {
        this.selectedUsesV2 = false
        this.contractList = []
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.card-glass {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(12px);
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 16px !important;
  transition: all 0.3s ease-in-out;
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.1) !important;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 32px 0 rgba(0, 150, 63, 0.2) !important;
  }
}

.custom-search-field ::v-deep .v-input__slot {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
  border-radius: 12px !important;
}
</style>
